import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { IssueState } from 'src/app/classes';
import { IssueTypes } from 'src/app/lib/shared/globals';
import { IIssueProviderService, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-select-status-form',
  templateUrl: './select-status-form.component.html',
  styleUrls: ['./select-status-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectStatusFormComponent),
      multi: true
    }
  ]
})
export class SelectStatusFormComponent implements ControlValueAccessor, OnInit {

  @Input() label: string = "Status";
  @Input() placeholder: string;
  @Input() showCurrentValues: boolean = false;
  @Input() appearance: string = 'fill';
  @Input() multiple: boolean = false;

  status: IssueState[] = [];

  formControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  /**
   * the constructor creates a new instance of the component
   * @param _formBuilder 
   * @param _dataService 
   */
  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) private _service: IIssueProviderService,
    private _issueService: IssueService
  ) { }
  /**
   * the method is called on component disposition
   */
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }
  /**
   * the method is called on component initalization
   */
  ngOnInit(): void {
    this._subscriptions.push(
      combineLatest([
        this._issueService.getAllIssueStatus(true),
        this._service.getCurrentIssueType()
      ]).subscribe({
        next: ([status, typeId]) => {
          this.setAvailableStatus(status, typeId);
        }
      })
    );
  }

  public onTouched: () => void = () => { };

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.formControl.valueChanges.subscribe(fn));
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  /**
   * the method sets the issue status in accordance to the issue type
   */
  setAvailableStatus(status, type: number = IssueTypes.Issue) {

    switch (type) {

      case IssueTypes.Change:
        this.status = status.filter(x => x.ischangestate);
        break;

      case IssueTypes.Incident:
        this.status = status.filter(x => x.isincidentstate);
        break;

      case IssueTypes.Project:
        this.status = status.filter(x => x.isprojectstate);
        break;

      default:
        this.status = status.filter(x => x.isissuestate);
        break;

    }

  }

  writeValue(val: any): void {
    if (val) this.formControl.setValue(val);
  }

}
